var _path;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTagsClick(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 3.75C9.075 3.75 6.75 6.075 6.75 9C6.75 10.8281 7.6575 12.4211 9.05273 13.3594C6.38251 14.5105 4.5 17.1702 4.5 20.25H6C6 16.95 8.7 14.25 12 14.25C14.925 14.25 17.25 11.925 17.25 9C17.25 6.075 14.925 3.75 12 3.75ZM12 5.25C14.1 5.25 15.75 6.9 15.75 9C15.75 11.1 14.1 12.75 12 12.75C9.9 12.75 8.25 11.1 8.25 9C8.25 6.9 9.9 5.25 12 5.25ZM15.75 14.25C14.925 14.25 14.25 14.925 14.25 15.75V19.0503L18.75 23.5503C19.05 23.8503 19.4253 24 19.8003 24C20.1753 24 20.5506 23.8503 20.8506 23.5503L23.5503 20.8506C23.8503 20.5506 24 20.1753 24 19.8003C24 19.4253 23.8503 19.05 23.5503 18.75L19.0503 14.25H15.75ZM15.75 15.75H18.4497L22.5 19.8003L19.8003 22.5L15.75 18.4497V15.75ZM17.25 16.5C17.0511 16.5 16.8603 16.5791 16.7197 16.7197C16.5791 16.8603 16.5 17.0511 16.5 17.25C16.5 17.4489 16.5791 17.6397 16.7197 17.7803C16.8603 17.9209 17.0511 18 17.25 18C17.4489 18 17.6397 17.9209 17.7803 17.7803C17.9209 17.6397 18 17.4489 18 17.25C18 17.0511 17.9209 16.8603 17.7803 16.7197C17.6397 16.5791 17.4489 16.5 17.25 16.5Z",
    fill: "#303030",
    stroke: "black",
    strokeWidth: 0.3
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTagsClick);
export default __webpack_public_path__ + "static/media/tags_click.343c5f2b048a8125a484e40a93c313f9.svg";
export { ForwardRef as ReactComponent };